exports = module.exports = require("../../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.first-box[data-v-773ed1f3]{\r\n  padding-left: 30px;\r\n  background-color: #f1f1f1;\r\n  height: 50px;\r\n  line-height: 50px;\n}\r\n", ""]);

// exports
